module.exports = __webpack_public_path__ + "static/media/av-villas-ico-pdf.21891755.svg";